<!-- src/components/LoginView.vue -->

<template>
  <div class="login">
    <div class="login-wrapper">
      <h1 class="login-title">Forgot Password</h1>
      <div class="login-alert" v-show="error" transition="fade">
        {{ error }}
      </div>

      <form class="login-form"
            v-if="$route.params.token"
            @submit.prevent="reset">

        <p>Enter a new password below to finish the reset.</p>
        <label class="form-full-width">
          <span>New Password</span>
          <input
              type="password"
              name="password"
              v-model="password" required>
        </label>

        <vue-button
            type="success"
            @click="reset()">Reset Password
        </vue-button>
      </form>

      <form class="login-form"
            v-else
            @submit.prevent="submit">
        <p>Enter your email below to receive a forgot password reset link.</p>
        <label class="form-full-width">
          <span>Email</span>
          <input
              type="email"
              name="email"
              v-model="email"
              @keyup.enter="submit" required>
        </label>

        <vue-button
            type="success"
            @click="submit()">Reset Password
        </vue-button>
      </form>
    </div>
  </div>
</template>

<script>

import auth from '../../services/Client/Auth';
import VueButton from '../Shared/VueButton.vue';

export default {

  components: {VueButton},

  data() {
    return {
      email: '',
      password: null,
      error: false,
      message: '',
    }
  },

  methods: {
    submit() {
      let self = this;
      auth.forgotPassword(this.email, function (data, success) {
        this.message = data.message;

        if (!success) {
          swal({
            title: "Error!",
            text: this.message,
            type: "error",
            confirmButtonColor: "#40B572"
          }, function () {
            swal.close();
          });

          return;
        }

        swal({
          title: "Sent!",
          text: this.message,
          type: "success",
          confirmButtonColor: "#40B572"
        }, function () {
          swal.close();
        });

      }.bind(this));
    },

    reset() {
      auth.resetPassword({reset_token: this.$route.params.token, newPassword: this.password}, function (data, success) {
        let self = this;
        debugger;
        this.message = data.message;
        if (!success) {
          swal({
            title: "Error!",
            text: this.message,
            type: "error",
            confirmButtonColor: "#40B572"
          }, function () {
            swal.close();
          });

          return;
        }
        this.email = data.user.email;

        swal({
          title: "Success!",
          text: this.message,
          type: "success",
          confirmButtonColor: "#40B572",
          confirmButtonText: "Go to Dashboard"
        }, function () {
          // Login the user and redirect him to root.
          auth.login({email: self.email, password: self.password}, (() => {
            swal.close();
            self.$router.push({ name: "projects" });
          }));
        });

      }.bind(this));
    }
  }
}
</script>

<style>
.login-wrapper {
    background: #FFF;
    font-family: var(--font-family);
    font-size: 14px;
    color: #969696;
    letter-spacing: 0;
    font-weight: 400;
    border: 1px solid #DDD;
    border-radius: 5px;
    display: block;
    position: relative;
    text-decoration: none;
    padding: 6px 12px;
    margin: 5px -175px;
    width: 350px;
    left: 50%;
    padding: 25px;
    margin-top: 50px;
}

.login-wrapper h1 {
    font-size: 24px;
    color: #4A4A4A;
    letter-spacing: 0;
    margin-top: 0px;
}

.login-form input {
    width: 100%;
    padding: 8px;
}

.login-alert {
    display: block;
    background: #f28a8c;
    color: #FFF;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 10px;
}
</style>
